import React from "react";
import { PrismicRichTextField } from "../../types/graphql";
import { PrismicRichText } from "@prismicio/react";

export type IAnnouncementProps = {
  announcementContent: PrismicRichTextField | null | undefined;
};

const Announcement = (props: IAnnouncementProps) => {
  const { announcementContent } = props;

  return (
    <div className="announcement-module bg-xom-blue-100 text-white text-center px-4 py-2">
      <div className="container">
        <PrismicRichText field={announcementContent?.richText} />
      </div>
    </div>
  );
};

export default Announcement;
